module.exports = __webpack_public_path__ + "static/media/search-home-stage-2.790c825c.svg";